'use client';

import { Listbox, Transition } from '@headlessui/react';
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid';
import { Fragment, useContext, useEffect, useState } from 'react';

import { LoadingSpinner } from '@/shared/ui';

import { ClinicsContext } from '..';
import { useClinics } from '../model';

export default function CategoryFilter() {
  const { uniqueCategories } = useClinics();
  const clinicsCtx = useContext(ClinicsContext);
  const { isLoading, setCategoryName } = clinicsCtx;
  const [selected, setSelected] = useState<string>('Категория не выбрана');

  useEffect(() => {
    if (!isLoading && uniqueCategories?.length) {
      setSelected('Категория не выбрана');
    }
  }, [isLoading, uniqueCategories]);

  const listboxChangeHandle = (catName: string) => {
    setSelected(catName);
    setCategoryName(catName);
  };

  return (
    <div className="mt-6 w-full text-left md:mt-0 md:w-72">
      <p>Фильтр:</p>
      <Listbox disabled={isLoading} value={selected} onChange={listboxChangeHandle}>
        <div className="relative mt-1">
          <div className="relative w-full rounded-lg border-2 bg-white text-left shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300 sm:text-sm">
            <Listbox.Button
              aria-label="ФильтрОрганизаций"
              className="w-full rounded-lg border-none bg-white py-2 pr-10 pl-3 text-[16px] leading-5 text-gray-900 focus:ring-0 dark:bg-slate-600 dark:text-white"
            >
              <span className="block truncate">{selected}</span>
              <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                {isLoading ? (
                  <LoadingSpinner size={5} />
                ) : (
                  <ChevronUpDownIcon
                    className="h-5 w-5 text-gray-400 dark:text-white"
                    aria-hidden="true"
                  />
                )}
              </span>
            </Listbox.Button>
            <Transition
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
                {uniqueCategories?.map((category, categoryIdx) => (
                  <Listbox.Option
                    key={categoryIdx}
                    className={({ active }) =>
                      `relative cursor-default py-2 pr-4 pl-10 select-none ${
                        active ? 'bg-yellow-600 text-white' : 'text-gray-900'
                      }`
                    }
                    value={category}
                  >
                    {({ selected }) => (
                      <>
                        <span
                          className={`block truncate ${selected ? 'font-medium' : 'font-normal'}`}
                        >
                          {category}
                        </span>
                        {selected ? (
                          <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-black">
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        </div>
      </Listbox>
    </div>
  );
}
